import { formatINR } from "@/lib/api";

/**
 * Returns "₹500 – ₹2,000" for flat payouts
 * or "0.5% – 1.5% of loan disbursed" for percentage payouts.
 * Handles single-value (min === max) by collapsing the range.
 */
export function formatPayout(p) {
  if (!p) return "";
  const min = Number(p.commission_min) || 0;
  const max = Number(p.commission_max) || 0;
  const same = min === max;
  if (p.payout_type === "percentage") {
    const fmt = (v) => `${(+v.toFixed(2))}%`;
    const range = same ? fmt(max) : `${fmt(min)} – ${fmt(max)}`;
    return p.payout_basis ? `${range} of ${p.payout_basis}` : range;
  }
  // default: flat ₹
  return same ? formatINR(max) : `${formatINR(min)} – ${formatINR(max)}`;
}

export function payoutUnit(p) {
  return p?.payout_type === "percentage" ? "%" : "₹";
}
